import { handleErrors } from './ErrorActions';
import smartSolveApi from '../api/instances/smartsolve';

export const OPEN_INSTALLED_VERSIONS_MODAL = 'OPEN_INSTALLED_VERSIONS_MODAL';
export const FETCH_INSTALLED_VERSIONS = 'FETCH_INSTALLED_VERSIONS';
export const FETCH_INSTALLED_VERSIONS_FAILURE = 'FETCH_INSTALLED_VERSIONS_FAILURE';
export const FETCH_INSTALLED_VERSIONS_SUCCESS = 'FETCH_INSTALLED_VERSIONS_SUCCESS';

export const openInstalledVersionsModal = () => ({
  type: OPEN_INSTALLED_VERSIONS_MODAL,
});

const fetchInstalledVersions = () => ({
  type: FETCH_INSTALLED_VERSIONS,
});

const fetchInstalledVersionsSuccess = ({ Result }) => ({
  type: FETCH_INSTALLED_VERSIONS_SUCCESS,
  columns: Result.Columns,
  rows: Result.Rows,
});

const fetchInstalledVersionsFailure = ({ message }) => ({
  type: FETCH_INSTALLED_VERSIONS_FAILURE,
  message,
});

export const fetchInstalledVersionsFromServer = () => async (dispatch, getState) => {
  const { topMenu } = getState();
  if (topMenu.fetchedInstalledVersions) {
    return;
  }

  dispatch(fetchInstalledVersions());

  return smartSolveApi
    .post('/installedversions', {})
    .then((response) => {
      const { data } = response;
      if (data.hasError) {
        dispatch(handleErrors(data.errors));
      } else {
        dispatch(fetchInstalledVersionsSuccess(data));
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(`Fetching Create PAT failed: ${JSON.stringify(error)}`);
      dispatch(fetchInstalledVersionsFailure(error));
      dispatch(handleErrors(error));
    });
};
